import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const EgCard = (props) => {
  const { egDetails } = props;
  // const settings = useSelector(state => state.user.settings);
  if (!egDetails) return <></>;
  // const unit = Unit.getInstance();

  // let completedAcres = 0;
  // if (egWorkDetails.data) completedAcres = egWorkDetails.data.worked_hectares ? egWorkDetails.data.worked_hectares * 2.47105 : 0;

  return (
    <Card className="vehicle-info">
      <Card.Body className="p-0 d-flex">
        <Row className="image-details">
          <Col className="p-0 image" md={4} sm={4} lg={4}>
            <img src={egDetails.img.lg} alt="" />
          </Col>
          <Col className="p-0 value">
            <div title={egDetails.equipment_group_name}>{egDetails.equipment_group_name}</div>
          </Col>
        </Row>
        {/* <div className="px-2 completion-details">
                <Col className="acres">
                    <Row className="value">{unit.toArea(completedAcres, 2)}</Row>
                    <Row className="label">{`Estimated Completed ${settings.areaShortName}`}</Row>
                </Col> */}
        {/* <Col className="p-0">
                    <Row className="value">0h 0m</Row>
                    <Row className="label">Completed Hrs.</Row>
                    </Col>
                    <Col className="p-0">
                        <Row className="value">0%</Row>
                        <Row className="label">Utilization</Row>
                    </Col> */}
        {/* </div> */}
      </Card.Body>
    </Card>
  );
};

export default EgCard;
